module.exports = __webpack_public_path__ + "img/fondo.738fa6ee.jpg";